import { storageLocationIdFormat } from "@redotech/redo-model/ids";
import { StorageLocationTableRowSchema } from "@redotech/redo-model/wms/schema/storage-location";
import * as z from "zod/v4";

export const getStorageLocationById = {
  name: "getStorageLocationById" as const,
  input: z.object({
    storageLocationId: storageLocationIdFormat.schema,
    includeZeroQuantity: z.boolean().optional(),
  }),
  output: z.object({
    storageLocation: StorageLocationTableRowSchema.nullable(),
  }),
};
